// PDF React View
import { tableFormateDate } from "pages/DataFormatInvoice/utils";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Label, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import { resetGetDataLink } from "store/actions";
import { GET_DATA_LINK_SUCCESS } from "store/issue-invoice/actionTypes";
const CompareInvoiceModal = props => {
  const dispatch = useDispatch();
  const { isOpen, toggle, showPdfById, dataCompare, setDataCompare } = props;

  const issueInvoice = useSelector(state => state.issueInvoice);
  const { type, linkTypeData } = issueInvoice;

  useEffect(() => {
    switch (type) {
      case GET_DATA_LINK_SUCCESS:
        const data = linkTypeData.data;
        let dataCompareFinal = dataCompare;

        if (data.child) {
          dataCompareFinal = {
            ...dataCompareFinal,
            rightInvoice: data.child.map(item => {
              return {
                id: item.id,
                khmshdon: item.ttchung_khmshdon,
                khhdon: item.ttchung_khhdon,
                shdon: item.ttchung_shdon,
                nlap: tableFormateDate(item.ttchung_nlap),
              };
            }),
          };
        }
        if (data.root) {
          dataCompareFinal = {
            ...dataCompareFinal,
            leftInvoice: {
              id: data.root.id,
              khmshdon: data.root.ttchung_khmshdon,
              khhdon: data.root.ttchung_khhdon,
              shdon: data.root.ttchung_shdon,
              nlap: tableFormateDate(data.root.ttchung_nlap),
            },
          };
        }
        setDataCompare(dataCompareFinal);
        dispatch(resetGetDataLink());
        break;
      default:
        break;
    }
  }, [type]);

  useEffect(() => {
    if (isOpen) {
    }
  }, [isOpen]);

  return (
    <Modal
      size="sm"
      contentClassName="confirm-modal"
      isOpen={isOpen}
      role="dialog"
      style={{ maxWidth: "80%" }}
      autoFocus={true}
      centered={true}
      className="exampleModal"
      toggle={toggle}
    >
      <div className="modal-content">
        <ModalHeader toggle={toggle}>
          <Label>Thông tin hóa đơn liên quan</Label>
        </ModalHeader>

        <React.Fragment>
          <ModalBody>
            <React.Fragment>
              <Row className="row-cols-1 row-cols-md-2">
                <Col
                  className="text-center text-danger"
                  style={{ borderRight: "1px solid #8080805c" }}
                >
                  <div className="text-danger font-size-16">
                    <strong>
                      Hóa đơn bị {dataCompare?.typeChange}{" "}
                      {dataCompare?.leftInvoice?.current}
                    </strong>
                  </div>
                  <table className="table ">
                    <thead>
                      <tr className="text-danger">
                        <th scope="col">Id</th>
                        <th scope="col">Mẫu số</th>
                        <th scope="col">Ký hiệu</th>
                        <th scope="col">Số hóa đơn</th>
                        <th scope="col">Ghi chú</th>
                        <th scope="col">Ngày lập</th>
                        <th scope="col"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td
                          title={
                            dataCompare?.leftInvoice?.id ===
                            dataCompare?.currentId
                              ? "Hóa đơn hiện tại"
                              : ""
                          }
                        >
                          <span
                            className={
                              dataCompare?.leftInvoice?.id ===
                              dataCompare?.currentId
                                ? "tag-chips"
                                : ""
                            }
                          >
                            {" "}
                            {dataCompare?.leftInvoice?.id}
                          </span>
                        </td>
                        <td>{dataCompare?.leftInvoice?.khmshdon}</td>
                        <td>{dataCompare?.leftInvoice?.khhdon}</td>
                        <td>{dataCompare?.leftInvoice?.shdon}</td>
                        <td>{dataCompare?.leftInvoice?.gchu}</td>
                        <td>{dataCompare?.leftInvoice?.nlap}</td>
                        <td className="text-left">
                          {dataCompare?.leftInvoice?.id && (
                            <i
                              onClick={() => {
                                showPdfById(dataCompare.leftInvoice.id);
                              }}
                              title="Bản hiển thị"
                              style={{ cursor: "pointer" }}
                              className="bx bxs-file-pdf label-icon font-size-20"
                            />
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Col>
                <Col className="text-center">
                  <div className="text-info font-size-16">
                    <strong>
                      Hóa đơn {dataCompare?.typeChange}
                      {dataCompare?.rightInvoice?.current}
                    </strong>
                  </div>
                  <table className="table">
                    <thead>
                      <tr className="text-info">
                        <th scope="col">Id</th>
                        <th scope="col">Mẫu số</th>
                        <th scope="col">Ký hiệu</th>
                        <th scope="col">Số hóa đơn</th>
                        <th scope="col">Ngày lập</th>
                        <th scope="col"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {dataCompare?.rightInvoice?.map(item => {
                        return (
                          <tr key={item?.id}>
                            <td
                              title={
                                item?.id === dataCompare?.currentId &&
                                "Hóa đơn hiện tại"
                              }
                            >
                              <span
                                className={
                                  item?.id === dataCompare?.currentId
                                    ? "tag-chips"
                                    : ""
                                }
                              >
                                {" "}
                                {item?.id}
                              </span>
                            </td>
                            <td>{item?.khmshdon}</td>
                            <td>{item?.khhdon}</td>
                            <td>{item?.shdon ? item?.shdon : "Chờ cấp số"}</td>
                            <td>{item?.nlap}</td>
                            <td className="text-left">
                              <i
                                onClick={() => {
                                  showPdfById(item?.id);
                                }}
                                title="Bản hiển thị"
                                style={{ cursor: "pointer" }}
                                className="bx bxs-file-pdf label-icon font-size-20"
                              />
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </Col>
              </Row>
            </React.Fragment>
          </ModalBody>
        </React.Fragment>
      </div>
    </Modal>
  );
};

CompareInvoiceModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  showPdfById: PropTypes.func,
  dataCompare: PropTypes.any,
  setDataCompare: PropTypes.any,
};

export default CompareInvoiceModal;
